import * as Reach from '@reach/menu-button';

import SocialsIcon from '#/assets/SocialsIcon';
import DiscordIcon from '#/assets/DiscordIcon';
import TwitterIcon from '#/assets/TwitterIcon';
import YouTubeIcon from '#/assets/YouTubeIcon';

import { DISCORD_URL, TWITTER_URL, YOUTUBE_URL } from '#/routes-external';

import { NavItemPopoverButton, PopoverMenu } from './PopoverMenu';

export default function SocialsMenu() {
  return (
    <Reach.Menu>
      <Reach.MenuButton as={NavItemPopoverButton}>
        <SocialsIcon />
      </Reach.MenuButton>
      <Reach.MenuList as={PopoverMenu}>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={DISCORD_URL}
        >
          <DiscordIcon /> Discord
        </Reach.MenuLink>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={TWITTER_URL}
        >
          <TwitterIcon /> Twitter
        </Reach.MenuLink>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={YOUTUBE_URL}
        >
          <YouTubeIcon /> YouTube
        </Reach.MenuLink>
      </Reach.MenuList>
    </Reach.Menu>
  );
}
